module.exports = __webpack_public_path__ + "img/repair.5736bc81.jpg";